var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7362 24.8745L68.666 29.7911L58.5629 39.7922L43.8624 25.2858L29.162 39.7922L7.72168 18.5625C-3.20085 34.5464 -1.55868 56.5955 12.6515 70.7761C20.701 78.8092 31.2122 82.8241 41.8056 82.8241C51.2505 82.8241 60.7777 79.5463 68.4159 73.1521L59.2178 63.9705C48.1308 72.5762 32.0316 71.839 21.8463 61.6767C16.5907 56.431 13.7967 49.5464 13.6322 42.6618L29.2376 58.0699L43.8559 43.4813L58.5564 57.9876L77.8575 38.9727L82.8663 43.9749V24.8745H63.7362Z",
    fill: "#7650FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.337 10.2036C52.567 -3.07521 29.0797 -2.66385 13.7178 11.5167L22.9159 20.616C28.257 15.8607 34.9902 13.4024 41.7234 13.4024C47.884 13.4024 53.9623 15.3703 59.0533 19.303L68.337 10.2036Z",
    fill: "#7650FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.2727,
    height: 82.2727,
    fill: "white",
    transform: "translate(0.600098 0.550781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinwLogo);
export default __webpack_public_path__ + "static/media/coinw-logo.b3d49ee7799394c18b6547224b9c7155.svg";
export { ForwardRef as ReactComponent };